module.exports = __webpack_public_path__ + "img/new_music.3d3aa2ff.svg";